class Materials {
  constructor(rawMaterialsData) {
    this.rawMaterials = rawMaterialsData.map(m => ({ ...m })); // raw materials data
  }

  init() {
    const initMaterials = this.rawMaterials.map(m => ({ ...m }));
    initMaterials.forEach((m) => {
      m.isError = false;
      m.trackId = 0;
      m.names = [];
      this.initMaterialAnswer(m);
    });
    return initMaterials;
  }

  initMaterialAnswer(m) {
    if (m.materialType === 2 || m.materialType === 6 || m.materialType === 7 || m.materialType === 9) { // checkbox, annex, photos...
      m.answer = [];
    }
    if (m.materialType === 8) {
      const optionArr = JSON.parse(m.materialAnswerTemplate); // [trueOption, falseOption](select falseOption by default)
      [, m.answer] = optionArr; // array destructuring syntax, same as m.answer = optionArr[1]
    }
    if (m.preQuestionId !== -1) {
      const preQuestion = this.rawMaterials.find(y => y.id === m.preQuestionId);
      const preQuestionOptionArr = JSON.parse(preQuestion.materialAnswerTemplate);
      const idx = JSON.parse(m.preQuestionAnswer)[0]; // convert stuff like "[0]", "[1]" to index
      m.preQuestionAnswer = preQuestionOptionArr[idx]; // replace preQuestionAnswer from index represtation to actual answer str
    }
  }

  // fill full length init materials with answers backend given
  fillInitMaterialsWithAnswers(materialsWithAnswers) {
    const initMaterials = this.init();
    materialsWithAnswers.forEach((m) => {
      let materialTemplate = initMaterials.find(initM => initM.id === m.materialOptionId);
      const index = initMaterials.findIndex(initM => initM.id === m.materialOptionId);
      if (materialTemplate) {
        materialTemplate = Object.assign({ ...materialTemplate }, { answer: m.answer, id: m.materialOptionId, trackId: m.id });
        materialTemplate.answer = materialTemplate.materialType === 3 || materialTemplate.materialType === 4 || materialTemplate.materialType === 5 ? materialTemplate.answer : JSON.parse(materialTemplate.answer);
        materialTemplate.answer = Materials.handleAnswerForDisplay(materialTemplate);
        if (materialTemplate.materialType === 6) {
          materialTemplate.names = materialTemplate.answer.map(a => a.split(',')[1]);
        }
        initMaterials[index] = materialTemplate;
      }
    });
    return initMaterials;
  }

  static handleAnswer(data, materials) {
    // sync answer
    const currentMaterial = materials.find(x => x.id === data.materialOptionId);
    // for question that support multiple answers (upload multiple annex ),
    // for checkbox type, since we use v-model to bind answer data,
    // it will automatically synchronized.
    if (data.type === 'annex' || data.type === 'document-photo') {
      currentMaterial.answer.push(data.answer);
    } else {
      // single answer
      currentMaterial.answer = data.answer;
    }
    // in case we want to display file name instead of URL(annex type)
    if (data.name) {
      currentMaterial.names.push(data.name);
    }
    // console.log(currentMaterial);
  }

  static handleDeleteImgOrAnnex(data, materials) {
    // sync answer
    const material = materials.find(x => x.id === data.materialId);
    material.answer = material.answer.filter((x, index) => index !== data.idx);
    // it's ok weather or not material.names has val
    material.names = material.names.filter((x, index) => index !== data.idx);
  }

  static handleAnswerForPost(material) {
    let answer;
    // replace answer with index
    if (material.materialType === 1 || material.materialType === 8) {
      const index = JSON.parse(material.materialAnswerTemplate).findIndex(a => a === material.answer);
      answer = JSON.stringify([index]);
    } else if (material.materialType === 2) {
      answer = [];
      material.answer.forEach((x) => {
        const index = JSON.parse(material.materialAnswerTemplate).findIndex(a => a === x);
        answer.push(index);
      });
      answer = JSON.stringify(answer);
    } else {
      answer = typeof material.answer === 'string' ? material.answer : JSON.stringify(material.answer);
    }
    return answer;
  }

  static handleAnswerForDisplay(material) {
    let answer;
    if (material.materialType === 1 || material.materialType === 8) { // radio or trueOrFalse
      const index = material.answer[0];
      answer = JSON.parse(material.materialAnswerTemplate)[index];
    } else if (material.materialType === 2) {
      answer = [];
      material.answer.forEach((x, idx) => {
        const materialAnswerTemplate = JSON.parse(material.materialAnswerTemplate);
        answer.push(materialAnswerTemplate[idx]);
      });
    } else {
      answer = material.answer;
    }
    return answer;
  }

  static checkIfNeedToSkip(material, materials) {
    // if material has preQuestion and preQuestion's answer is not its needed, skip this one
    let skipCheck = false;
    if (material.preQuestionId !== -1) {
      const preQuestion = materials.find(m => m.id === material.preQuestionId);
      skipCheck = material.preQuestionAnswer !== preQuestion.answer;
    }
    return skipCheck;
  }

  static checkIsRequiredFinished(materials, isForExternal) {
    // filter all true false type
    // if all required is empty(not for external), pass check, other show error msg
    const temp = materials.filter(m => m.materialType !== 8);
    const allRequiredLength = temp.filter(m => m.isRequired && !m.skipCheck).length;
    const allEmptyRequiredLength = temp.filter(m => m.isRequired && !m.skipCheck && (!m.answer || !m.answer.length)).length;
    const isAllRequiredEmpty = allRequiredLength === allEmptyRequiredLength;
    materials.forEach((x) => {
      if (!x.skipCheck) {
        x.isError = (x.isRequired && (!x.answer || x.answer === null || !x.answer.length));
        if (isAllRequiredEmpty && typeof isForExternal === 'undefined') {
          x.isError = false;
        }
      } else {
        x.isError = false;
      }
    });
    return materials;
  }

  static checkIsRequiredFinishedBeforePost(materials) {
    const hasEmptyRequired = materials.filter(x => !x.skipCheck && x.isRequired && (!x.answer || x.answer === null || !x.answer.length)).length;
    return hasEmptyRequired ? [] : materials;
  }

  static bindHistoryMaterialsData(model, materials) {
    model.forEach((x) => {
      const sameMaterial = materials.find(y => y.id === x.materialOptionId);
      let template;
      if (sameMaterial) {
        switch (sameMaterial.materialType) {
          case 1:
          case 8:
            try {
              template = JSON.parse(sameMaterial.materialAnswerTemplate);
              sameMaterial.answer = template[JSON.parse(x.answer)[0]];
            } catch (error) {
              console.log(error);
            }
            break;
          case 3:
          case 4:
          case 5:
            sameMaterial.answer = x.answer;
            break;
          case 2:
            template = JSON.parse(sameMaterial.materialAnswerTemplate);
            sameMaterial.answer = JSON.parse(x.answer).map(y => template[y]);
            break;
          case 7:
          case 9:
            sameMaterial.answer = JSON.parse(x.answer);
            break;
          case 6: // 附件
            sameMaterial.answer = JSON.parse(x.answer);
            sameMaterial.names = sameMaterial.answer.map(z => z.split(',')[1]);
            break;
          default:
            break;
        }
      }
    });
  }
}

export default Materials;
